import {NgModule} from '@angular/core';
import {FileUploadComponent} from './file-upload.component';
import {CommonModule} from '@angular/common';
import {TranslatePipe, TranslateDirective} from '@ngx-translate/core';
import {LoadingModule} from '../loading/loading.module';

@NgModule({
  declarations: [FileUploadComponent],
  imports: [
    CommonModule,
    TranslatePipe, TranslateDirective,
    LoadingModule
  ],
  exports: [FileUploadComponent]
})
export class FileUploadModule { }
